module.exports = __webpack_public_path__ + "img/banner-solution.c3c1914b.png";